var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/features/ui/components/theme-toggle.tsx";
import React from 'react';
import { useDispatch } from 'react-redux';
import { changeSetting } from 'soapbox/actions/settings';
import { useSettings } from 'soapbox/hooks';
import ThemeSelector from './theme-selector';

/** Stateful theme selector. */
const ThemeToggle = () => {
  const dispatch = useDispatch();
  const themeMode = useSettings().get('themeMode');
  const handleChange = themeMode => {
    dispatch(changeSetting(['themeMode'], themeMode));
  };
  return /*#__PURE__*/React.createElement(ThemeSelector, {
    value: themeMode,
    onChange: handleChange,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 19,
      columnNumber: 5
    }
  });
};
export default ThemeToggle;